import { render, staticRenderFns } from "./show_mobile.vue?vue&type=template&id=dcb77fde&scoped=true&"
import script from "./show_mobile.vue?vue&type=script&lang=js&"
export * from "./show_mobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb77fde",
  null
  
)

export default component.exports